'use client';

import Sidebar from '@/components/common/Sidebar';
import CheckInsInteractive from './components/CheckInsInteractive';

export default function CheckInsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <main className="pt-20 pb-[88px] lg:pb-8 max-w-[960px] mx-auto px-6 w-full">
        <div className="p-4 md:p-6 lg:p-8">
          <CheckInsInteractive />
        </div>
      </main>
    </div>
  );
}